<template>
  <div class="activity">
    <div class="main-contain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "activity",
  components: {},
  data() {
    return {
      isMobile: false, // 判断手机端字段
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getBrowserMobile();
  },
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false; // 判断是否是手机浏览
      return this.isMobile;
    },
  },
};
</script>
<style scoped lang="scss">
.activity {
  .main-contain {
    width: 100%;
  }
}
</style>
